module.exports = __webpack_public_path__ + "img/fa-solid-900.4927936.svg";